import React, { useMemo, forwardRef } from 'react'
import classnames from 'classnames'

import styles from './styles.module.scss'

export enum CircleButtonVariant {
  Primary = 'primary',
  Secondary = 'secondary',
}

type CircleButtonBaseProps = {
  label: string
  variant?: 'primary' | 'secondary'
  type?: 'button' | 'submit' | 'reset'
  icon: React.ElementType
  className?: string
}

type ButtonAsButton = CircleButtonBaseProps &
  Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, keyof CircleButtonBaseProps>

export type CircleButtonProps = ButtonAsButton

export const CircleButton = forwardRef<HTMLButtonElement, CircleButtonProps>(
  ({ className = '', variant = 'primary', icon, type = 'button', label, ...rest }, ref) => {
    const classes = classnames(styles['button'], styles[variant], className)

    const renderChildren = useMemo(() => {
      const Icon = icon as React.ElementType
      return (
        <>
          <span className={styles['hidden-label']}>{label}</span>
          <Icon className={styles['icon']} />
        </>
      )
    }, [icon, label])

    return (
      <button className={classes} type={type} ref={ref} title={label} {...rest}>
        {renderChildren}
      </button>
    )
  }
)

export default CircleButton
